import { IGetAllEntregaProdutoServicoUseCase } from "../../../presentation/useCases/read/get_all_entrega_produto_servico_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { ProdutoServicoEntregue } from "../../models/entrega_ordem_compra_produto_servico";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetAllEntregaProdutoServicoUseCase
 */

export class GetAllEntregaProdutoServicoUseCase
  extends BasePaginatedUseCase<ProdutoServicoEntregue>
  implements IGetAllEntregaProdutoServicoUseCase {
  constructor(private readonly repository: IComprasRepository) {
    super();
  }

  async getAllEntregaProdutoServico(
    idOrdemCompra: number | undefined,
    produtosServicos: number[] | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idOrdemCompra === undefined) throw new Error("Falha ao obter o ID da ordem de compra!");

    const response = await this.repository.getAllEntregaProdutoServico(
      idOrdemCompra,
      produtosServicos,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
